/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListTicketTariffResponse as AgentApiContractListTicketTariffResponse } from '../../models/AgentApi/Contract/list-ticket-tariff-response';

export interface ApiAgentListTicketTariffGet$Params {

/**
 * * Interface language
 */
  lang?: string;

/**
 * * terminal id
 */
  termCode?: string;
}

export function apiAgentListTicketTariffGet(http: HttpClient, rootUrl: string, params?: ApiAgentListTicketTariffGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListTicketTariffGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('termCode', params.termCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListTicketTariffResponse>>;
    })
  );
}

apiAgentListTicketTariffGet.PATH = '/api/Agent/ListTicketTariff';
